module.exports = __webpack_public_path__ + "static/media/power-hp.96afeb84.png";